export class ErrorConstant {
  static readonly NO_INTERNET_CONNECTION =
    'The device does not have internet connectivity or it’s too slow. Click RETRY. If you are still unable to connect, please contact your IT Department for assistance.';
  static readonly REGISTER_DEVICE_ERROR = 'Unable to register device. Click RETRY.';
}
